import ProjectList from "./Projects/ProjectList";
import TeamMemberList from "./TeamMembers/TeamMemberList";

const Sidebar = () => {
  return (
    <div className="sidebar">
      <ProjectList />

      <TeamMemberList />
    </div>
  );
};

export default Sidebar;
